import { Box } from '@mui/material';
import React from 'react';
import ElementDataRow from 'components/common/element-data/ElementDataRow';
import { ElementMetadataFieldName, IElementDataMaximumEver } from 'components/common/element-data/types';
import ElementDataRowLabel from 'components/common/element-data/ElementDataRowLabel';
import ElementDataRowValue from 'components/common/element-data/ElementDataRowValue';
import useBundleTranslation from 'i18n';
import { getFieldElementMetadataSettings } from 'components/common/element-data/functions';

export default function MaximumEver(props: IElementDataMaximumEver) {
    const { t } = useBundleTranslation(['components/common/element_data']);
    const { elementType = '', maxValue = '', maxReachedOn = '', settings } = props;
    const fieldKey: ElementMetadataFieldName = 'maximum_ever';
    const { fieldMetadataDisplay, fieldMetadataOrder } = getFieldElementMetadataSettings(settings, fieldKey);

    if (!fieldMetadataDisplay || !['metric', 'multi-metric chart'].includes(elementType) || !maxValue) return null;

    return (
        <ElementDataRow order={fieldMetadataOrder}>
            <ElementDataRowLabel>{t(`element_data_label.${fieldKey}`)}</ElementDataRowLabel>
            <ElementDataRowValue>
                <Box component={'span'} sx={{ fontWeight: 600 }}>
                    {maxValue}
                </Box>
                {maxReachedOn && <> {maxReachedOn}</>}
            </ElementDataRowValue>
        </ElementDataRow>
    );
}
